export default __webpack_public_path__ + "static/media/CapaCreateIcon.4b567342.svg";